"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateOfferItemHandler = updateOfferItemHandler;
var _updateOfferItemFailed = require("@ori-events/update-offer-item-failed");
var _checkoutUtils = require("@ori/checkout-utils");
var _api = require("../api");
var _logger = require("../logger");
var _types = require("../types");
var _utils = require("../utils");
const dispatchErrorEvent = detail => {
  const errorEvent = new CustomEvent(_updateOfferItemFailed.Name, {
    detail
  });
  window.dispatchEvent(errorEvent);
};
async function updateOfferItemHandler({
  detail: {
    choiceId,
    itemCode,
    quantity
  }
}, {
  client,
  sessionId,
  tenant
}) {
  // STEP 1 - Update through API
  try {
    await (0, _api.updateOfferItem)({
      client,
      itemCode,
      offerId: choiceId,
      quantity,
      sessionId,
      tenant
    });
  } catch (error) {
    _logger.mainLogger.error(error, {
      message: 'Error while updating offer item in update-offer-item event.'
    });
    dispatchErrorEvent({
      isSuccess: false,
      localizedMessage: '',
      message: 'Updating of offer item failed via API call'
    });
    return false;
  }

  // STEP 2 - Update shopping context via Online endpoint
  const response = await fetch(_types.RequestUrl.GetShoppingContext, (0, _utils.getHttpRequestSettings)(undefined, _checkoutUtils.HttpMethod.Post));
  const data = (0, _utils.convertToCamelCase)(await response.json());
  if ((0, _updateOfferItemFailed.isUpdateOfferItemFailedResponse)(data)) {
    dispatchErrorEvent(data);
    return false;
  }
  return data;
}